import { render, staticRenderFns } from "./PropertiesSearchDesktopFiltersV2.vue?vue&type=template&id=39df3e24&scoped=true"
import script from "./PropertiesSearchDesktopFiltersV2.vue?vue&type=script&lang=js"
export * from "./PropertiesSearchDesktopFiltersV2.vue?vue&type=script&lang=js"
import style0 from "./PropertiesSearchDesktopFiltersV2.vue?vue&type=style&index=0&id=39df3e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39df3e24",
  null
  
)

export default component.exports